import axios from "@/axios";
import { StatisticsInput } from "@/Schemas/Statistics/StatisticsInput";
import { StatisticsOutput, StatisticsOutputSchema } from "@/Schemas/Statistics/StatisticsOutput";
import { StatisticsSourceInput } from "@/Schemas/Statistics/StatisticsSourceInput";
import { StatisticsSourceOutput, StatisticsSourceOutputSchema } from "@/Schemas/Statistics/StatisticsSourceOutput";
import { parseSchema } from "@/Utils/zodParser";
import { getQueryString } from "vig-ui-library";

export const getStatistics = async (input: StatisticsInput): Promise<StatisticsOutput> => {
    const dateFrom = input.dateFrom.toISOString().split("T")[0];
    const dateTo = input.dateTo.toISOString().split("T")[0];
    const queryString = getQueryString({ ...input, dateFrom, dateTo });
    const url = `/api/statistics?${queryString}`;
    const response = await axios.get(url);
    return parseSchema(StatisticsOutputSchema, response.data);
}

export const getSourceStatistics = async (input: StatisticsSourceInput): Promise<StatisticsSourceOutput> => {
    const dateFrom = input.dateFrom.toISOString().split("T")[0];
    const dateTo = input.dateTo.toISOString().split("T")[0];
    const queryString = getQueryString({ ...input, dateFrom, dateTo });
    const url = `/api/statistics/source?${queryString}`;
    const response = await axios.get(url);
    return parseSchema(StatisticsSourceOutputSchema, response.data);
}